export default __webpack_public_path__ + "static/media/DetailedInspection.ecd10e92.svg";